var map = {
	"./arrow-right.svg": 395,
	"./bsc.jpg": 396,
	"./coinbaseWalletIcon.svg": 231,
	"./fortmaticIcon.png": 232,
	"./metamask.png": 152,
	"./portisIcon.png": 233,
	"./walletConnectIcon.svg": 234
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 267;